import React from "react"
import DocViewer, {DocViewerRenderers} from "@cyntler/react-doc-viewer";
import TableContainer from "@mui/material/TableContainer";
import {Card} from "@mui/material";
import Button from "@mui/material/Button";
import {stepButtonSXHandler} from "../../usefuls/helpers";
import {useRouter} from "../../usefuls/hooks";
import { useSelector } from "react-redux";

const ThirdStep = () => {
    const router = useRouter();
    const wordViewUrl = useSelector(state => state.matters.wordViewUrl)
    const currentStep = +window.location.search.split("?step=")[1]
    const fileName = wordViewUrl?.split("/storage/")[1]
    const docs = [
        {
            uri: wordViewUrl,
            fileType: "docx",
            fileName: fileName
        },
    ];

    const handleExport = () => {
        const link = document.createElement("a");
        link.href = docs[0].uri;
        link.download = docs[0].fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleChangeStep = (step) => {
        router.queryPush({ step })
    }

    return (
        <Card sx={{pt: "20px", pb: "20px", pr: "20px"}}>
            <TableContainer sx={{overflow: 'unset'}}>
                <DocViewer
                    documents={docs}
                    pluginRenderers={DocViewerRenderers}
                    style={{ height: 1000 }}
                />
                <Button
                    sx={{...stepButtonSXHandler({float: {float: "left"}}), marginLeft: "50px"}}
                    onClick={() => handleChangeStep(currentStep - 1)}
                >
                    Previous Step
                </Button>
                <Button
                    sx={{...stepButtonSXHandler({float: { float: "right" } }), marginRight: "50px"}}
                    onClick={handleExport}
                >
                    Export Document
                </Button>
            </TableContainer>
        </Card>
    );
}

export default ThirdStep;